import "./FieldLabel.scss";

// Shared label for every form field (TextInput, SelectInput, HeightInput) so
// required fields look the same everywhere: a trailing "*" in the title is
// split out and rendered in the error color instead of plain text.
const FieldLabel = ({ htmlFor, id, children }) => {
  const text = String(children ?? "");
  const isRequired = text.endsWith("*");
  const label = isRequired ? text.slice(0, -1).trim() : text;
  const content = (
    <>
      {label}
      {isRequired && <span className="field-label_required">*</span>}
    </>
  );

  return htmlFor ? (
    <label className="field-label" htmlFor={htmlFor}>
      {content}
    </label>
  ) : (
    <span className="field-label" id={id}>
      {content}
    </span>
  );
};

export default FieldLabel;
